// FILE: src/components/studyplan/CertRoadmap.js
//
// Full-width certification roadmap: 7 milestones with derived statuses,
// grouped under PM Pixel's Prepare · Practice · Pass arcs.

import React from 'react';
import styles from './StudyPlanViewPage.module.css';
import { ROADMAP_ARCS, MILESTONE_STATUS } from '../../services/studyPlanRoadmap';
import { formatDateShort } from './studyPlanHelpers';

const S = MILESTONE_STATUS;

const NODE_GLYPH = {
  [S.COMPLETE]: '✓',
  [S.NEEDS_ATTENTION]: '!',
};

export default function CertRoadmap({ roadmap, currentId }) {
  if (!roadmap || roadmap.length === 0) return null;
  return (
    <section className={styles.card} data-testid="study-plan-view-roadmap">
      <div className={styles.cardHeader}>
        <span className={styles.cardEyebrow}>Certification Roadmap</span>
      </div>
      <div className={styles.arcRow} aria-hidden="true">
        {ROADMAP_ARCS.map((a) => (
          <div key={a.id} className={`${styles.arc} ${styles['arc_' + a.id]}`} style={{ gridColumn: `span ${a.span}` }}>
            <span className={styles.arcName}>{a.label}</span>
          </div>
        ))}
      </div>
      <div className={styles.road}>
        {roadmap.map((m, idx) => {
          const cls = [
            styles.node,
            m.status === S.COMPLETE ? styles.nodeDone : '',
            m.status === S.NEEDS_ATTENTION ? styles.nodeWarn : '',
            m.status === S.IN_PROGRESS || m.id === currentId ? styles.nodeCurrent : '',
          ].filter(Boolean).join(' ');
          const glyph = NODE_GLYPH[m.status] || (m.id === 'exam' ? '★' : String(idx + 1));
          const detail = m.id === 'exam' && m.detail !== '—' ? formatDateShort(m.detail) : m.detail;
          const stateCls = [
            styles.nodeState,
            m.status === S.COMPLETE ? styles.nsDone : '',
            m.status === S.NEEDS_ATTENTION ? styles.nsWarn : '',
            m.status === S.IN_PROGRESS ? styles.nsCurrent : '',
          ].filter(Boolean).join(' ');
          return (
            <div key={m.id} className={cls} data-testid={`roadmap-${m.id}`}>
              <div className={styles.nodeDot}>{glyph}</div>
              <div className={styles.nodeLabel}>{m.label}</div>
              <div className={stateCls}>{detail}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
